import { render, staticRenderFns } from "./MemberRoleSelection.vue?vue&type=template&id=0b50e98b&scoped=true&"
import script from "./MemberRoleSelection.vue?vue&type=script&lang=js&"
export * from "./MemberRoleSelection.vue?vue&type=script&lang=js&"
import style0 from "./MemberRoleSelection.vue?vue&type=style&index=0&id=0b50e98b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b50e98b",
  null
  
)

export default component.exports